import { React, useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Divider, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { HttpHandler } from '../../shared/httpHandler.js';
import PropTypes from 'prop-types';

const httpHandler = new HttpHandler();
const { Dragger } = Upload;

// 新增、修改Modal
const UploadModal = (props) => {
  const { uploadVisible, setUploadVisible, updateData } = props;

  const [loading, setLoading] = useState(false);
  const [modalForm] = Form.useForm();

  const addChange = async () => {
    const formdata = new FormData();
    const data = await modalForm.validateFields();

    setLoading(true);

    formdata.append('upload_file', data.uploadfile.file);

    httpHandler
      .post('/service_location/upload_multiple_location', formdata, {
        headers: {
          'Content-Type': 'multipart/form-data; charset=UTF-8',
        },
      })
      .then((response) => {
        if (response.success) {
          const success_msg = (
            <>
              <span>批次更新成功！</span>

              {/* 只有當 response.data 有資料時，才渲染下方區塊 */}
              {response.data && response.data.length > 0 && (
                <>
                  <br />
                  <br />
                  <span>下方代碼為尚未新增資料：</span>
                  <br />
                  {response.data.map((item, index) => (
                    <span key={index}>
                      {item}
                      <br />
                    </span>
                  ))}
                </>
              )}
            </>
          );

          updateData();
          modalForm.resetFields();
          setUploadVisible(false);
          setLoading(false);
          window.antdNotify('成功', success_msg, 'success');
        } else {
          const fail_msg = (
            <>
              {response.data.map((item, index) => (
                <span key={index}>
                  {item}
                  <br />
                </span>
              ))}
            </>
          );
          modalForm.resetFields();
          setUploadVisible(false);
          setLoading(false);
          window.antdNotify(response.message, fail_msg, 'fail');
        }
      });
  };

  const handleModalSubmit = async () => {
    try {
      let alert = '確定上傳據點檔案？';

      const confirmed = await window.antdConfirm(alert);
      if (!confirmed) {
        return;
      }

      await addChange();
    } catch (error) {
      console.log(error);
    }
  };

  const handleModalCancel = () => {
    modalForm.resetFields();

    setLoading(false);
    setUploadVisible(false);
  };

  // 新增時的預設值
  useEffect(() => {
    setLoading(true);
    setLoading(false);
  }, [uploadVisible]);

  return (
    <Modal
      title={'批次更新據點'}
      open={uploadVisible}
      onCancel={handleModalCancel}
      footer={[
        <Button key="back" onClick={handleModalCancel}>
          取消
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleModalSubmit}
          loading={loading}>
          確定
        </Button>,
      ]}
      okButtonProps={{ loading: loading }}>
      <ModalForm modalForm={modalForm} />
    </Modal>
  );
};

// 共用Modal專用的Form(新增、修改共用)
const ModalForm = (props) => {
  const { modalForm } = props;

  const handleChange = (file) => {
    console.log('file upload success!');
  };

  return (
    <Form
      form={modalForm}
      labelCol={{ span: 6 }} // 設置標籤佔據的列數
      wrapperCol={{ span: 16 }}>
      <Divider></Divider>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="uploadfile">
        <Dragger
          name="批次檔上傳"
          accept=".xlsx"
          maxCount={1}
          style={{ width: '150%' }}
          beforeUpload={() => false}
          onChange={(file) => {
            handleChange(file);
          }}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">點擊或拖曳檔案到此區域上傳</p>
          <p className="ant-upload-hint">
            僅支援單一檔案上傳，且檔案格式需為.xlsx !
          </p>
        </Dragger>
      </Form.Item>
      <Form.Item style={{ width: '130%' }}>
        <div style={{ color: '#888', lineHeight: 1.6 }}>
          <div>• 相關名稱請依照不同範例檔中各自清單頁面進行填寫</div>
          <div>• 批次上傳會統一將物品的“當前庫存”改為“庫存總數”</div>
        </div>
      </Form.Item>
    </Form>
  );
};

// 驗證props
UploadModal.propTypes = {
  isManageVisible: PropTypes.bool,
  setIsManageVisible: PropTypes.func,
};

ModalForm.propTypes = {
  modalForm: PropTypes.object,
};

export default UploadModal;
